/* import __COLOCATED_TEMPLATE__ from './part-inserter.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();